/*
 * @Author: LHH
 * @Date: 2019-12-18 17:19:13
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {}
})
